module.exports = __webpack_public_path__ + "static/img_9444-072d57c2ff4cab36b5a3ec9a61c6e443.webp";